// src/hooks/useAuth.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        axios.get('/api/auth/checkAuth')
            .then(response => {
                if (response.data.isAuthenticated) {
                    setIsAuthenticated(true);
                    setUser(response.data.user);
                } else {
                    setIsAuthenticated(false);
                    setUser(null);
                }
            })
            .catch(error => {
                console.error('Error checking authentication:', error);
                setIsAuthenticated(false);
                setUser(null);
            });
    }, []);

    return { isAuthenticated, user };
};
